module.exports = {
  zone_1: [
    8000,
    8001,
    8002,
    8003,
    8004,
    8005,
    8006,
    8008,
    8020,
    8021,
    8022,
    8023,
    8024,
    8025,
    8026,
    8027,
    8028,
    8029,
    8030,
    8031,
    8032,
    8033,
    8034,
    8035,
    8036,
    8037,
    8038,
    8039,
    8040,
    8041,
    8042,
    8043,
    8045,
    8046,
    8047,
    8048,
    8049,
    8050,
    8051,
    8052,
    8053,
    8055,
    8056,
    8057,
    8058,
    8060,
    8061,
    8062,
    8063,
    8064,
    8065,
    8066,
    8079,
    8087,
    8091
  ],
  zone_2: [
    8044,
    8102,
    8105,
    8125,
    8134,
    8142,
    8152,
    8153,
    8304,
    8600,
    8702,
    8802,
    8952
  ],
  zone_3: [
    8103,
    8108,
    8117,
    8122,
    8126,
    8302,
    8305,
    8700,
    8803,
    8902,
    8903,
    8953
  ],
  zone_4: [
    8104,
    8143,
    8303,
    8306,
    8602,
    8603,
    8604,
    8610,
    8800,
    8703,
    8907,
    8951,
    8954,
    8955,
    8957
  ],
  zone_5: [8123, 8124, 8135, 8704, 8810, 8910, 8956, 8964]
}
